<template>
    <div :style="{ width: '100%', height: '100%', backgroundImage: `url(${backgroundImage})` }">
        <v-container v-if="dataLoaded">
            <v-card>
                <v-card-title color="hubblue" dark class="justify-center">
                    Document Title: {{ docTitle }}
                </v-card-title>
                <v-container style="text-align:center">
                    <form>
                        <v-flex px-5>
                            <v-textarea
                                outline
                                v-model="comment"
                                label="Message"
                                auto-grow
                                rows="1"
                                :error-messages="errors.collect('comment')"
                                v-validate="'required'"
                                data-vv-name="comment"
                            ></v-textarea>
                        </v-flex>

                        <v-row>
                            <v-flex xs12 sm6 lg2 d-flex px-8>
                                <v-btn small class="hubblue" dark @click="upLoadFiles = !upLoadFiles">
                                    <v-icon dark v-if="!upLoadFiles">
                                        mdi-cloud-upload
                                    </v-icon>
                                    <v-icon dark left v-else>
                                        mdi-minus-circle
                                    </v-icon>
                                    {{ buttonText }}
                                </v-btn>
                            </v-flex>
                        </v-row>
                        <v-flex class="xs12" v-if="upLoadFiles">
                            <multi-file-upload
                                :files="multiFiles"
                                @fileUploadList="fileListChanged"
                            ></multi-file-upload>
                        </v-flex>
                        <v-flex class="text-xs-center" px-5>
                            <v-btn
                                color="green"
                                class="white--text"
                                @click="openConfirmationDialogNoValidation(1)"
                                :loading="loading"
                                :disabled="loading"
                                data-cy="btnRegister"
                                >Approve</v-btn
                            >
                            <v-btn
                                ref="requestChangesButton"
                                color="red"
                                class="white--text"
                                @click="openConfirmationDialogValidation(2, 'comment')"
                                :loading="loading"
                                :disabled="loading"
                                data-cy="btnRegister"
                                >Request Changes</v-btn
                            >
                        </v-flex>
                        <v-flex md5 px-5>
                            <v-text-field
                                outline
                                v-model="delegateEmail"
                                label="Delegate Email:"
                                :error-messages="errors.collect('Email')"
                                v-validate="'required|email'"
                                data-vv-name="Email"
                            ></v-text-field>
                        </v-flex>
                        <v-flex class="text-xs-center" px-5>
                            <v-btn
                                color="orange"
                                class="white--text"
                                @click="openConfirmationDialogValidation(5, 'Email')"
                                :loading="loading"
                                :disabled="loading"
                                data-cy="btnRegister"
                                >Delegate</v-btn
                            >
                        </v-flex>
                    </form>
                </v-container>
            </v-card>

            <v-dialog v-model="confirmationDialog" max-width="450px">
                <v-card>
                    <div v-if="loading !== true">
                        <v-flex xs12>
                            <v-card-title class="hubblue white--text">Confirmation</v-card-title>
                        </v-flex>
                        <v-card-text class="black--text mt-2">
                            <p class="body-1">
                                {{ approvalStateDisplayText[selectedApprovalState] }}
                            </p>
                            <p class="body-1" v-if="comment !== null && comment !== ''">
                                With the comment of {{ comment }}.
                            </p>
                            <div v-if="requestChanges">
                                <p class="body-1">Send the request changes to:</p>

                                <v-radio-group v-model="reviewerSelected" :mandatory="true">
                                    <v-radio label="All Reviewers" value="All Reviewers"></v-radio>
                                    <v-radio label="Initiator Only" value="Initiator Only"></v-radio>
                                </v-radio-group>
                            </div>

                            <p class="body-1">
                                Is this correct?
                            </p>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                class="blue--text darken-1"
                                :disabled="confirmationLoading"
                                @click.native="confirmationDialog = false"
                                >Cancel</v-btn
                            >
                            <v-spacer />
                            <v-btn
                                :loading="confirmationLoading"
                                :disabled="confirmationLoading"
                                class="blue--text darken-1"
                                @click.native="updateApproval()"
                                >Confirm</v-btn
                            >
                        </v-card-actions>
                    </div>
                    <div v-else>
                        <v-progress-circular :size="70" :width="7" color="hubblue" indeterminate></v-progress-circular>
                    </div>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'
import multiFileUpload from '../../components/Helpers/multiFileUpload'

export default {
    components: {
        'multi-file-upload': multiFileUpload
    },
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            multiFiles: [],
            upLoadFiles: false,
            loading: false,
            confirmationLoading: false,
            snackbar: false,
            requestChanges: false,
            snackbarMessage: null,
            snackbarContext: '',
            docId: 0,
            verification: '',
            email: '',
            comment: null,
            approvalStateId: 0,
            delegateEmail: null,
            docTitle: '',
            selectedApprovalState: null,
            confirmationDialog: false,
            reviewerSelected: 'All Reviewers',
            approvalStateDisplayText: {},
            backgroundImage: '/img/bgd-banner.jpg',
            dataLoaded: false
        }
    },
    computed: {
        receiver() {
            return this.reviewerSelected === 'All Reviewers' ? true : false
        },
        buttonText() {
            return this.upLoadFiles ? 'Hide The Form' : 'ADD Document'
        }
    },
    methods: {
        fileListChanged(newFileList) {
            this.multiFiles = newFileList
        },
        getDocumentApproval(docId, verification, email) {
            let app = this
            let params = {
                docId: docId,
                verification: verification,
                email: email
            }
            axios
                .get(this.$store.state.docApprovalUrl, {
                    params: params
                })
                .then(response => {
                    app.docId = response.data.docId
                    app.email = response.data.email
                    app.approvalStateId = response.data.approvalStateId
                    app.comment = response.data.comment
                    app.dataLoaded = true
                })
                .catch(error => {
                    console.log(error)
                    let snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    this.$router.push({ name: 'Home' })
                })
        },
        openConfirmationDialogValidation(approvalStateId, field) {
            this.$validator.reset().then(() => {
                this.$validator
                    .validate(field)
                    .then(validated => {
                        if (validated) {
                            this.selectedApprovalState = approvalStateId
                            if (approvalStateId === 2) {
                                this.requestChanges = true
                            }
                            if (approvalStateId === 5) {
                                this.approvalStateDisplayText[
                                    approvalStateId
                                ] = `You have chosen to delegate ${this.docTitle} to ${this.delegateEmail}.`
                            }
                            this.confirmationDialog = true
                        }
                    })
                    .catch(() => {
                        return false
                    })
            })
        },
        openConfirmationDialogNoValidation(approvalStateId) {
            this.selectedApprovalState = approvalStateId
            this.confirmationDialog = true
        },
        updateApproval() {
            const app = this
            app.confirmationLoading = true
            let snackbarParams
            let formData = new FormData()
            formData.append('docId', app.docId)
            formData.append('verification', app.verification)
            formData.append('receiver', app.receiver)
            formData.append('email', app.email)
            formData.append('approvalStateId', app.selectedApprovalState)
            formData.append('comment', app.comment)
            formData.append('delegateEmail', app.delegateEmail)
            formData.append('originUrl', window.location.origin)
            for (let i = 0; i < app.multiFiles.length; i++) {
                formData.append('multiFiles', app.multiFiles[i])
            }
            let headers = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            axios
                .patch(this.$store.state.docApprovalUrl, formData, headers)
                .then(response => {
                    app.confirmationLoading = false
                    snackbarParams = {
                        message: 'Your response has been saved successfully!',
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    if (app.$store.state.authentication.status.loggedIn) {
                        app.$router.push({ name: 'Dashboard' })
                    } else {
                        app.$router.push({ name: 'After Approval' })
                    }
                })
                .catch(error => {
                    console.log(error)
                    app.confirmationLoading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        }
    },
    created() {
        //if the user is logged in then give a white background, else use the default fractal background
        //makes for more consitent presentation between logged in white background pages and not logged in fractal backgrounds
        if (this.$store.state.authentication.loggedInUser) {
            this.backgroundImage = ''
        }

        if (this.$route.query.docId && this.$route.query.ah && this.$route.query.email) {
            this.docId = this.$route.query.docId
            this.verification = this.$route.query.ah
            this.email = this.$route.query.email
            this.docTitle = this.$route.query.title
            this.getDocumentApproval(this.docId, this.verification, this.email)

            this.approvalStateDisplayText = {
                1: `You have chosen to approve ${this.docTitle}.`,
                2: `You have requested changes to ${this.docTitle}.`
            }
        } else {
            this.$router.push({ name: 'Home' })
        }
    }
}
</script>
